import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { getApiUrl } from '../config';
import PageHead from '../components/PageHead';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing');
        return;
      }

      try {
        const response = await axios.get(`${getApiUrl()}/auth/verify-email?token=${token}`);
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message);
          // Redirect to login after 3 seconds
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus('error');
          setMessage(response.data.error || 'Verification failed');
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'An error occurred during verification');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(120deg, #2575fc 0%, #6a11cb 100%)',
        padding: '20px',
      }}
    >
      <PageHead 
        title="Verify Email" 
        description="Verify your email address for AutoBlogPilot"
      />
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          width: '100%',
          maxWidth: 400,
          borderRadius: '12px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          textAlign: 'center',
        }}
      >
        {status === 'verifying' && (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="h6">Verifying your email...</Typography>
          </>
        )}

        {status === 'success' && (
          <>
            <Typography
              variant="h5"
              sx={{
                color: 'success.main',
                mb: 2,
                fontWeight: 600,
              }}
            >
              Email Verified Successfully!
            </Typography>
            <Typography>
              {message}
            </Typography>
            <Typography sx={{ mt: 2, color: 'text.secondary' }}>
              Redirecting to login page...
            </Typography>
          </>
        )}

        {status === 'error' && (
          <>
            <Typography
              variant="h5"
              sx={{
                color: 'error.main',
                mb: 2,
                fontWeight: 600,
              }}
            >
              Verification Failed
            </Typography>
            <Typography color="error">
              {message}
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default VerifyEmail; 